function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.0095238 18L20 9L0.0095238 0L0 7L14.2857 9L0 11L0.0095238 18Z",
  fill: "black",
  fillOpacity: 0.2
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/SendIcon.2d0b7a1a.svg";
export { SvgComponent as ReactComponent };